import { httpConstants } from "../constants";
import { httpService } from "../utility/httpService";

export default {
  forgotPassword,
  addUser,
  getUsersList,
  getUsersByRole,
  getUser,
  addAdmin,
  changePassword,
};
function getHeaders() {
  return {
    "Content-Type": httpConstants.CONTENT_TYPE.APPLICATION_JSON,
    skip: true,
    "Access-Control-Allow-Origin": "*",
    'x-api-key': process.env.REACT_APP_API_KEY
  };
}
async function forgotPassword(requestData) {
  let url =
    process.env.REACT_APP_NFT_AUTH0_SERVICE_URL +
    httpConstants.API_END_POINT.FORGOT_PASSWORD;
  return httpService(
    httpConstants.METHOD_TYPE.POST,
    getHeaders(),
    requestData,
    url
  )
    .then((response) => {
      if (
        !response.success ||
        response.responseCode !== 200 ||
        !response.responseData ||
        response.responseData.length === 0
      )
        return Promise.reject(response);
      return Promise.resolve(response.responseData);
    })
    .catch(function (err) {
      return Promise.reject(err);
    });
}

async function addUser(requestData) {
  let url =
    process.env.REACT_APP_NFT_AUTH0_SERVICE_URL +
    httpConstants.API_END_POINT.ADD_USER;
  return httpService(
    httpConstants.METHOD_TYPE.POST,
    getHeaders(),
    requestData,
    url
  )
    .then((response) => {
      if (
        !response.success ||
        response.responseCode !== 200 ||
        !response.responseData ||
        response.responseData.length === 0
      )
        return Promise.reject(response);
      return Promise.resolve(response.responseData);
    })
    .catch(function (err) {
      return Promise.reject(err);
    });
}

async function getUsersList(requestData) {
  let url =
    process.env.REACT_APP_NFT_AUTH0_SERVICE_URL +
    httpConstants.API_END_POINT.GET_USERS_LIST;
  return httpService(
    httpConstants.METHOD_TYPE.POST,
    getHeaders(),
    requestData,
    url
  )
    .then((response) => {
      if (
        !response.success ||
        response.responseCode !== 200 ||
        !response.responseData ||
        response.responseData.length === 0
      )
        return Promise.reject(response);
      return Promise.resolve(response.responseData);
    })
    .catch(function (err) {
      return Promise.reject(err);
    });
}

async function getUsersByRole(requestData) {
  let url =
    process.env.REACT_APP_NFT_AUTH0_SERVICE_URL +
    httpConstants.API_END_POINT.GEY_USERS_BY_ROLE;
  return httpService(
    httpConstants.METHOD_TYPE.POST,
    getHeaders(),
    requestData,
    url
  )
    .then((response) => {
      if (
        !response.success ||
        response.responseCode !== 200 ||
        !response.responseData ||
        response.responseData.length === 0
      )
        return Promise.reject(response);
      return Promise.resolve(response.responseData);
    })
    .catch(function (err) {
      return Promise.reject(err);
    });
}

async function getUser(requestData) {
  let url =
    process.env.REACT_APP_NFT_AUTH0_SERVICE_URL +
    httpConstants.API_END_POINT.GET_USER;
  return httpService(
    httpConstants.METHOD_TYPE.POST,
    getHeaders(),
    requestData,
    url
  )
    .then((response) => {
      if (
        !response.success ||
        response.responseCode !== 200 ||
        !response.responseData ||
        response.responseData.length === 0
      )
        return Promise.reject(response);
      return Promise.resolve(response.responseData);
    })
    .catch(function (err) {
      return Promise.reject(err);
    });
}

async function addAdmin(requestData) {
  let url =
    process.env.REACT_APP_NFT_AUTH0_SERVICE_URL +
    httpConstants.API_END_POINT.ADD_ADMIN;
  return httpService(
    httpConstants.METHOD_TYPE.POST,
    getHeaders(),
    requestData,
    url
  )
    .then((response) => {
      if (
        !response.success ||
        response.responseCode !== 200 ||
        !response.responseData ||
        response.responseData.length === 0
      )
        return Promise.reject(response);
      return Promise.resolve(response.responseData);
    })
    .catch(function (err) {
      return Promise.reject(err);
    });
}
async function changePassword(requestData) {
  let url =
    process.env.REACT_APP_NFT_AUTH0_SERVICE_URL +
    httpConstants.API_END_POINT.CHANGE_PASSWORD;
  return httpService(
    httpConstants.METHOD_TYPE.POST,
    getHeaders(),
    requestData,
    url
  )
    .then((response) => {
      if (
        !response.success ||
        response.responseCode !== 200 ||
        !response.responseData ||
        response.responseData.length === 0
      )
        return Promise.reject(response);
      return Promise.resolve(response.responseData);
    })
    .catch(function (err) {
      return Promise.reject(err);
    });
}
